import {
  GET_ADMIN_DASHBOARD_1,
  GET_ADMIN_DASHBOARD_2,
  GET_ADMIN_DASHBOARD_3,
  GET_ADMIN_DASHBOARD_4,
  GET_ADMIN_DASHBOARD_5,
  GET_ADMIN_DASHBOARD_6,
  GET_ADMIN_DASHBOARD_7,
  GET_ADMIN_DASHBOARD_8,
  GET_ADMIN_DASHBOARD_9,
  GET_ADMIN_CUMULATIVE_DASHBOARD_URL,
  GET_INSTITUTION_DASHBOARD_1,
  GET_INSTITUTION_DASHBOARD_2,
  GET_INSTITUTION_DASHBOARD_3,
  GET_INSTITUTION_DASHBOARD_4,
  GET_INSTITUTION_DASHBOARD_5,
  GET_INSTITUTION_DASHBOARD_6,
  GET_INSTITUTION_DASHBOARD_7,
  GET_INSTITUTION_DASHBOARD_8,
  GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_1,
  GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_2,
  GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_3,
  GET_TEACHER_CUMULATIVE_DASHBOARD_URL_1,
  GET_TEACHER_CUMULATIVE_DASHBOARD_URL_2,
  GET_TEACHER_CUMULATIVE_DASHBOARD_URL_3,
  GET_TEACHER_DASHBOARD_1,
  GET_TEACHER_DASHBOARD_2,
  GET_TEACHER_DASHBOARD_3,
  GET_TEACHER_DASHBOARD_4,
  GET_TEACHER_DASHBOARD_5,
  GET_TEACHER_DASHBOARD_6,
  GET_TEACHER_DASHBOARD_7,
  GET_TEACHER_DASHBOARD_8,
} from "../apiurls/apiurls";

const fetchWithAuth = async (url, token) => {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  });

  if (!response.ok) {
    let msg = `HTTP error! status: ${response.status}`;
    try {
      const errJson = await response.json();
      if (errJson && (errJson.message || errJson.error)) {
        msg = String(errJson.message || errJson.error);
      }
    } catch (_) {}
    throw new Error(msg);
  }

  return response.json();
};

export const getAdminDashboard1 = async (token) => {
  return fetchWithAuth(GET_ADMIN_DASHBOARD_1, token);
};

export const getAdminDashboard2 = async (token, institutionId) => {
  const qs = institutionId
    ? `?institution_id=${encodeURIComponent(institutionId)}`
    : "";
  return fetchWithAuth(`${GET_ADMIN_DASHBOARD_2}${qs}`, token);
};

export const getAdminDashboard3 = async (token, courseKey, institutionId) => {
  const params = new URLSearchParams();
  if (courseKey) params.set("key", courseKey);
  if (institutionId) params.set("institution_id", institutionId);
  const qs = params.toString() ? `?${params.toString()}` : "";
  return fetchWithAuth(`${GET_ADMIN_DASHBOARD_3}${qs}`, token);
};

export const getAdminDashboard4 = async (token, batchId) => {
  const qs = batchId ? `?batch_id=${encodeURIComponent(batchId)}` : "";
  return fetchWithAuth(`${GET_ADMIN_DASHBOARD_4}${qs}`, token);
};

export const getAdminDashboard5 = async (token) => {
  return fetchWithAuth(GET_ADMIN_DASHBOARD_5, token);
};

export const getAdminDashboard6 = async (token, teacherId, courseKey) => {
  const id = teacherId ? String(teacherId) : "";
  const course = courseKey ? String(courseKey) : "";
  const courseQs = course ? `&course_key=${encodeURIComponent(course)}` : "";

  if (!id) {
    const qs = course ? `?course_key=${encodeURIComponent(course)}` : "";
    return fetchWithAuth(`${GET_ADMIN_DASHBOARD_6}${qs}`, token);
  }

  try {
    return await fetchWithAuth(
      `${GET_ADMIN_DASHBOARD_6}?teacher_id=${encodeURIComponent(id)}${courseQs}`,
      token,
    );
  } catch (e) {
    return fetchWithAuth(
      `${GET_ADMIN_DASHBOARD_6}?id=${encodeURIComponent(id)}${courseQs}`,
      token,
    );
  }
};

export const getInstitutionCumulativeDashboardOverview = async (token) => {
  return fetchWithAuth(GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_1, token);
};

export const getInstitutionCumulativeDashboardCourseOverview = async (
  token,
  courseKey,
) => {
  const key = courseKey ? String(courseKey) : "";
  const qs = key ? `?course_key=${encodeURIComponent(key)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_2}${qs}`, token);
};

export const getInstitutionCumulativeDashboardBatchOverview = async (
  token,
  batchId,
) => {
  const id = batchId ? String(batchId) : "";
  const qs = id ? `?batch_id=${encodeURIComponent(id)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_CUMULATIVE_DASHBOARD_URL_3}${qs}`, token);
};

export const getAdminCumulativeDashboard = async (token) => {
  return fetchWithAuth(GET_ADMIN_CUMULATIVE_DASHBOARD_URL, token);
};

export const getInstitutionDashboard1 = async (token) => {
  return fetchWithAuth(GET_INSTITUTION_DASHBOARD_1, token);
};

export const getInstitutionDashboard2 = async (token, courseKey) => {
  const qs = courseKey ? `?key=${encodeURIComponent(courseKey)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_2}${qs}`, token);
};

export const getInstitutionDashboard2WithFilters = async (
  token,
  courseKey,
  { subjectKey = "", topicKey = "", subtopicKey = "" } = {},
) => {
  const key = courseKey ? String(courseKey) : "";
  const params = new URLSearchParams();
  if (key) params.set("key", key);
  if (subjectKey) params.set("subject_key", String(subjectKey));
  if (topicKey) params.set("topic_key", String(topicKey));
  if (subtopicKey) params.set("subtopic_key", String(subtopicKey));
  const qs = params.toString() ? `?${params.toString()}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_2}${qs}`, token);
};

export const getInstitutionDashboard3 = async (token, batchId) => {
  const qs = batchId ? `?batch_id=${encodeURIComponent(batchId)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_3}${qs}`, token);
};

export const getInstitutionDashboard4 = async (token) => {
  return fetchWithAuth(GET_INSTITUTION_DASHBOARD_4, token);
};

export const getInstitutionDashboard5 = async (token, teacherId, courseKey) => {
  const id = teacherId ? String(teacherId) : "";
  const course = courseKey ? String(courseKey) : "";
  const courseQs = course ? `&course_key=${encodeURIComponent(course)}` : "";

  if (!id) {
    const qs = course ? `?course_key=${encodeURIComponent(course)}` : "";
    return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_5}${qs}`, token);
  }

  try {
    return await fetchWithAuth(
      `${GET_INSTITUTION_DASHBOARD_5}?teacher_id=${encodeURIComponent(id)}${courseQs}`,
      token,
    );
  } catch (e) {
    return fetchWithAuth(
      `${GET_INSTITUTION_DASHBOARD_5}?id=${encodeURIComponent(id)}${courseQs}`,
      token,
    );
  }
};

export const getAdminDashboard7 = async (token, batchId) => {
  const qs = batchId ? `?batch_id=${encodeURIComponent(batchId)}` : "";
  return fetchWithAuth(`${GET_ADMIN_DASHBOARD_7}${qs}`, token);
};

export const getAdminDashboard8 = async (token, userId) => {
  const qs = userId ? `?user_id=${encodeURIComponent(userId)}` : "";
  return fetchWithAuth(`${GET_ADMIN_DASHBOARD_8}${qs}`, token);
};

export const getAdminDashboard9 = async (token, userId) => {
  const qs = userId ? `?user_id=${encodeURIComponent(userId)}` : "";
  return fetchWithAuth(`${GET_ADMIN_DASHBOARD_9}${qs}`, token);
};

export const getInstitutionDashboard6 = async (token, batchId) => {
  const qs = batchId ? `?batch_id=${encodeURIComponent(batchId)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_6}${qs}`, token);
};

export const getInstitutionDashboard7 = async (token, userId) => {
  const qs = userId ? `?user_id=${encodeURIComponent(userId)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_7}${qs}`, token);
};

export const getInstitutionDashboard8 = async (token, userId) => {
  const qs = userId ? `?user_id=${encodeURIComponent(userId)}` : "";
  return fetchWithAuth(`${GET_INSTITUTION_DASHBOARD_8}${qs}`, token);
};

export const getTeacherCumulativeDashboardOverview = async (token) => {
  return fetchWithAuth(GET_TEACHER_CUMULATIVE_DASHBOARD_URL_1, token);
};

export const getTeacherCumulativeDashboardCourseOverview = async (token, courseKey) => {
  const qs = courseKey ? `?course_key=${encodeURIComponent(courseKey)}` : "";
  return fetchWithAuth(`${GET_TEACHER_CUMULATIVE_DASHBOARD_URL_2}${qs}`, token);
};

export const getTeacherCumulativeDashboardBatchOverview = async (token, batchId) => {
  const qs = batchId ? `?batch_id=${encodeURIComponent(batchId)}` : "";
  return fetchWithAuth(`${GET_TEACHER_CUMULATIVE_DASHBOARD_URL_3}${qs}`, token);
};
